"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ConstantsReducer = undefined;

var _apiBaseDataConstant = require("../../actions/esdb/apiBaseDataConstant");

var ConstantsReducer = exports.ConstantsReducer = function ConstantsReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		data: null,
		error: null,
		loading: false
	};
	var action = arguments[1];

	var newState = void 0;
	switch (action.type) {
		case _apiBaseDataConstant.API_BASE_DATA_CONSTANT_REQUEST:
			return Object.assign({}, state, action.payload);

		case _apiBaseDataConstant.API_BASE_DATA_CONSTANT_SUCCESS:
			var newData = Object.assign({}, state.data);
			Object.values(action.payload.data).map(function (v) {
				newData[v["NAME"]] = v;
			});
			return {
				data: newData,
				loading: action.payload.loading,
				error: action.payload.error
			};
			break;

		default:
			return state;
	}
};